// extracted by mini-css-extract-plugin
export var Banner = "style-module--Banner--dc43a";
export var Body = "style-module--Body--f7b8e";
export var Details = "style-module--Details--2d12a";
export var Footer = "style-module--Footer--6ea1b";
export var Header = "style-module--Header--ae86b";
export var SlideDescription = "style-module--SlideDescription--ad4b8";
export var TourVideo = "style-module--TourVideo--0a930";
export var TourVideoContainer = "style-module--TourVideoContainer--307a8";
export var Walkthroughs = "style-module--Walkthroughs--f21cf";